import { Box } from "@mui/material";
import CardComponent from "./CardComponent";

export default function GameGrid({
  cards,
  flippedIndices,
  matchedCards,
  onCardClick,
  cols,
}) {
  return (
    <Box
      className="game-grid"
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: `repeat(${cols}, 72px)`,
          sm: `repeat(${cols}, 92px)`,
          md: `repeat(${cols}, 108px)`,
        },
        gridAutoRows: {
          xs: "72px",
          sm: "92px",
          md: "108px",
        },
        gap: { xs: 1.25, sm: 1.5, md: 1.75 },
        justifyContent: "center",
        justifyItems: "stretch",
        mt: 1,
        mx: "auto",
        px: 0,
      }}
    >
      {cards.map((value, index) => (
        <CardComponent
          key={index}
          value={value}
          index={index}
          onClick={onCardClick}
          flipped={flippedIndices.includes(index)}
          matched={matchedCards.includes(index)}
        />
      ))}
    </Box>
  );
}
